import React, { useContext, useEffect, useState } from "react";
import './Heather.css'
import Offcanvas from 'react-bootstrap/Offcanvas';
import menu from '../Images/menu.png'
import { Link } from 'react-router-dom';
import addDevice from '../Images/menu/addDevice.png'
import choice from '../Images/menu/choice.png'
import addUser from '../Images/menu/addUser.png'
import changeAdmin from '../Images/menu/changeAdmin.png'
import reportSwitch from '../Images/menu/reportSwitch.png'
import area from '../Images/menu/area.png'
import fabrikControl from '../Images/menu/fabrikControl.png'
import childLock from '../Images/menu/childLock.png'
import maxSpeed from '../Images/menu/maxSpeed.png'
import autoLock from '../Images/menu/autoLock.png'
import simManager from '../Images/menu/simManager.png'
import charge from '../Images/menu/charge.png'
import listen from '../Images/menu/listen.png'
import mic from '../Images/menu/mic.png'
import modeAlarm from '../Images/menu/modeAlarm.png'
import sendService from '../Images/menu/sendService.png'
import dingDong from '../Images/menu/dingDong.png'
import pasSet from '../Images/menu/pasSet.png'
import selectLanguage from '../Images/menu/selectLanguage.png'
import inbox from '../Images/menu/inbox.png'
import support from '../Images/menu/support.png'
import question from '../Images/menu/question.png'
import contact from '../Images/menu/contact.png'
import site from '../Images/menu/site.png'

import AddDevice from './AddDevice'
import SelectDevice from './SelectDevice'
import AddUser from './AddUser'
import ChangeAdmin from './ChangeAdmin'
import ReportSwitch from './ReportSwitch'
import Fabric from './Fabric'
import Charge from './Charge'
import LockChild from './LockChild'
import Mic from './Mic'
import MaxSpeed from './MaxSpeed'
import LockAuto from './LockAuto'
import Dingdang from './Dingdang'
import AccessCall from './AccessCall'
import Valet from './Valet'
import AlarmMode from './AlarmMode'

export default function Heather() {
    const [showAddDevice, setShowAddDevice] = useState(false)
    const [showSelectDevice, setShowSelectDevice] = useState(false)
    const [showAddUser, setShowAddUser] = useState(false)
    const [showChangeAdmin, setShowChangeAdmin] = useState(false)
    const [showReportSwitch, setShowReportSwitch] = useState(false)
    const [showFabric, setShowFabric] = useState(false)
    const [showCharge, setShowCharge] = useState(false)
    const [showLockChild, setShowLockChild] = useState(false)
    const [showMic, setShowMic] = useState(false)
    const [showMaxSpeed, setShowMaxSpeed] = useState(false)
    const [showLockAuto, setShowLockAuto] = useState(false)
    const [showDingdang, setShowDingdang] = useState(false)
    const [showAccessCall, setShowAccessCall] = useState(false)
    const [showValet, setShowValet] = useState(false)
    const [showAlarmMode, setShowAlarmMode] = useState(false)


    const [show, setShow] = useState(false);
    const hideAll = () => {
        setShowAddDevice(false)
        setShowSelectDevice(false)
        setShowAddUser(false)
        setShowChangeAdmin(false)
        setShowReportSwitch(false)
        setShowFabric(false);
        setShowCharge(false)
        setShowLockChild(false)
        setShowMic(false)
        setShowMaxSpeed(false)
        setShowLockAuto(false)
        setShowDingdang(false)
        setShowAccessCall(false)
        setShowValet(false)
        setShowAlarmMode(false)
    }

    const handleClose = () => {
        setShow(false);
        hideAll();
    }
    const handleShow = () => setShow(true);



    useEffect(() => {
    }, []);
    const CreateMenuItem = ({ img, caption, onClick, to }) => {
        return (
            <>
                <Link
                    to={to}
                    className="text-decoration-none"
                    onClick={e => {
                        if (to)
                            return;
                        e.preventDefault();
                        e.stopPropagation();
                        if (onClick)
                            onClick(e)
                        else
                            handleClose();
                    }}>
                    <div className="row">
                        <div className="col d-flex justify-content-center">
                            <img src={img} className="imgCanvasMenuItem" />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col d-flex justify-content-center">
                            <span className="text-white font1">{caption}</span>
                        </div>
                    </div>
                </Link>
            </>
        )
    }

    return (
        <>
            {showAddDevice && <AddDevice show={showAddDevice} handleClose={e => { setShowAddDevice(false) }} />}
            {showSelectDevice && <SelectDevice show={showSelectDevice} handleClose={e => { setShowSelectDevice(false) }} />}
            {showAddUser && <AddUser show={showAddUser} handleClose={e => { setShowAddUser(false) }} />}
            {showChangeAdmin && <ChangeAdmin show={showChangeAdmin} handleClose={e => { setShowChangeAdmin(false) }} />}
            {showReportSwitch && <ReportSwitch show={showReportSwitch} handleClose={e => { setShowReportSwitch(false) }} />}
            {showFabric && <Fabric show={showFabric} handleClose={e => { setShowFabric(false) }} />}
            {showCharge && <Charge show={showCharge} handleClose={e => { setShowCharge(false) }} />}
            {showLockChild && <LockChild show={showLockChild} handleClose={e => { setShowLockChild(false) }} />}
            {showMic && <Mic show={showMic} handleClose={e => { setShowMic(false) }} />}
            {showMaxSpeed && <MaxSpeed show={showMaxSpeed} handleClose={e => { setShowMaxSpeed(false) }} />}
            {showLockAuto && <LockAuto show={showLockAuto} handleClose={e => { setShowLockAuto(false) }} />}
            {showDingdang && <Dingdang show={showDingdang} handleClose={e => { setShowDingdang(false) }} />}
            {showAccessCall && <AccessCall show={showAccessCall} handleClose={e => { setShowAccessCall(false) }} />}
            {showValet && <Valet show={showValet} handleClose={e => { setShowValet(false) }} />}
            {showAlarmMode && <AlarmMode show={showAlarmMode} handleClose={e => { setShowAlarmMode(false) }} />}

            <Offcanvas
                show={show}
                onHide={handleClose}
                className="canvasPlace"  >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title> </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="row">
                        <div className="col">
                            <CreateMenuItem
                                img={addDevice}
                                caption="افزودن ردیاب"
                                onClick={e => {
                                    hideAll();
                                    setShowAddDevice(true)
                                }} />
                        </div>
                        <div className="col">
                            <CreateMenuItem
                                img={choice}
                                caption="انتخاب خودرو"
                                onClick={e => {
                                    hideAll();
                                    setShowSelectDevice(true)
                                }} />
                        </div>
                        <div className="col">
                            <CreateMenuItem
                                img={addUser}
                                caption="افزودن کاربر"
                                onClick={e => {
                                    hideAll();
                                    setShowAddUser(true)
                                }} />
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col">
                            <CreateMenuItem
                                img={changeAdmin}
                                caption="تغییر مدیر"
                                onClick={e => {
                                    hideAll();
                                    setShowChangeAdmin(true)
                                }}
                            />
                        </div>
                        <div className="col">
                            <CreateMenuItem
                                img={reportSwitch}
                                caption="گزارش سوئیچ"
                                onClick={e => {
                                    hideAll();
                                    setShowReportSwitch(true)
                                }}
                            />
                        </div>
                        <div className="col">
                            <CreateMenuItem img={area} caption="حصار جغرافیایی" />
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col">
                            <CreateMenuItem
                                img={fabrikControl}
                                caption="کنترل فابریک"
                                onClick={e => {
                                    hideAll();
                                    setShowFabric(true)
                                }}
                            />

                        </div>
                        <div className="col">
                            <CreateMenuItem
                                img={childLock}
                                caption="قفل کودک"
                                onClick={e => {
                                    hideAll();
                                    setShowLockChild(true)
                                }}
                            />
                        </div>
                        <div className="col">
                            <CreateMenuItem
                                img={maxSpeed}
                                caption="حداکثر سرعت"
                                onClick={e => {
                                    hideAll();
                                    setShowMaxSpeed(true)
                                }} />
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col">
                            <CreateMenuItem
                                img={autoLock}
                                caption="قفل اتوماتیک"
                                onClick={e => {
                                    hideAll();
                                    setShowLockAuto(true)
                                }}
                            />
                        </div>
                        <div className="col">
                            <CreateMenuItem
                                img={dingDong}
                                caption="هشدار دینگ دانگ"
                                onClick={e => {
                                    hideAll();
                                    setShowDingdang(true)
                                }}
                            />
                        </div>
                        <div className="col">
                            <CreateMenuItem
                                img={charge}
                                caption="استعلام شارژ"
                                onClick={e => {
                                    hideAll();
                                    setShowCharge(true)
                                }}
                            />
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col">
                            <CreateMenuItem
                                img={listen}
                                caption="دسترسی شنود"
                                onClick={e => {
                                    hideAll();
                                    setShowAccessCall(true)
                                }}
                            />
                        </div>
                        <div className="col">
                            <CreateMenuItem
                                img={mic}
                                caption="حساسیت میکروفون"
                                onClick={e => {
                                    hideAll();
                                    setShowMic(true)
                                }} />
                        </div>
                        <div className="col">
                            <CreateMenuItem
                                img={modeAlarm}
                                caption="نوع هشدار"
                                onClick={e => {
                                    hideAll();
                                    setShowAlarmMode(true)
                                }}
                            />
                        </div>
                    </div>
                    <div className="row mt-2">
                        <div className="col">
                            <CreateMenuItem
                                img={sendService}
                                caption="اعزام به تعمیرگاه"
                                onClick={e => {
                                    hideAll();
                                    setShowValet(true)
                                }}
                            />
                        </div>

                        <div className="col">
                            <CreateMenuItem
                                img={question}
                                caption="سوالات"
                                to="https://noroncar.ir/%d9%85%d8%b4%da%a9%d9%84%d8%a7%d8%aa-%d8%a7%d8%ad%d8%aa%d9%85%d8%a7%d9%84%db%8c" />
                        </div>
                        <div className="col">
                            <CreateMenuItem
                                img={site}
                                caption="سایت نورون"
                                to="https://noroncar.ir/"
                            />
                        </div>
                    </div>
                </Offcanvas.Body>
            </Offcanvas>
            <div
                id="header"
                className="d-flex col-xl-4 col-md-4 col-sm-8   align-items-center  ">
                <Link
                    onClick={e => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleShow();
                    }}>
                    <img
                        src={menu}
                        className="menuHeader m-2"
                    />
                </Link>
                <div className="d-flex w-100 justify-content-center fs-4 ">
                    <span className="me-2 fw-bold text-color1">NORON</span>
                    <span className="me-2 fw-bold text-light">GPS</span>
                </div>

            </div>
        </>

    );

}
